import { createApp } from 'vue'
import ImageLink from '../imagelink';
import MyI18n from '../plugins/my_i18n'
//import { createApp } from 'vue';
const App = {
  el: '#imagelink',
  propsData: { ...da.dataset },
  props: ["url", "url2", "text"],
  template: '<ImageLink :url="url" :url2="url2" :text="text"/>',
  components: { ImageLink }
};
const app = createApp(App);
app.config.devtools = true
app.config.productionTip = false
app.use(MyI18n)
  /* eslint-disable no-new */
var da;
document.addEventListener('DOMContentLoaded', () => {
  da = document.querySelector("#imagelink");
  new Vue({
    el: '#imagelink',
    propsData: { ...da.dataset },
    props: ["url", "url2", "text"],
    template: '<ImageLink :url="url" :url2="url2" :text="text"/>',
    components: { ImageLink },
  })
});
var dat;
document.addEventListener('DOMContentLoaded', () => {
  dat = document.querySelector("#imagelink2");
  new Vue({
    el: '#imagelink2',
    propsData: { ...dat.dataset },
    props: ["url", "url2", "text"],
    template: '<ImageLink :url="url" :url2="url2" :text="text"/>',
    components: { ImageLink },
  })
});

/*
const app = createApp(
  {
    props: ['signURL'],
  },
  { signURL: 'Evan' }
  )
createApp(Pop).mount("#pop");
*/
